import { ref } from 'vue'
import { getContext } from '@/utils/general'

// Live email recipient count for a selected message list: the server's
// send-preview count, which honours the list's ignore-opt-in and bounce rules,
// so it matches who the send reaches. The stats snapshot counts opted-in fans
// only, which is too low for an event's "All attendees" list (EC-4647).
export function useLiveEmailRecipientCount() {
  const count = ref<number | null>(null)
  const countedListOid = ref<number | null>(null)
  let latestRequest = 0

  async function refresh(promoterOid: number, messageListOid: number | null, ignoreSuppressed: boolean): Promise<void> {
    const request = ++latestRequest
    if (!messageListOid) {
      count.value = null
      countedListOid.value = null
      return
    }

    let result: number | null
    try {
      const { $api } = getContext()
      result = await $api.messageLists.fetchMessageListRecipientCount(
        promoterOid,
        messageListOid,
        null,
        'email',
        { messageSendPreview: true, ignoreSuppressed },
      )
    }
    catch (error) {
      console.error(error)
      result = null
    }

    // A slower earlier request must not overwrite a newer one.
    if (request !== latestRequest) return
    count.value = result
    countedListOid.value = result === null ? null : messageListOid
  }

  const countFor = (messageListOid: number | null | undefined): number | null =>
    messageListOid != null && messageListOid === countedListOid.value ? count.value : null

  return { countFor, refresh }
}
